import { useId, useState } from 'react';
import { Icono } from './Icono';
import './campos.css';

/**
 * RV Fecha (componentes.md §8b): la píldora de RV Campo con el calendario delante y la etiqueta arriba. Valor en
 * `AAAA-MM-DD` (fecha local, `LocalDate` del contrato) o vacío («Sin elegir»). Por ahora abre el calendario del sistema
 * (con años en móvil y en ordenador); el calendario propio del diseño, con la rejilla de años, queda para cuando lo
 * pidan varias pantallas.
 */
interface Props {
    etiqueta: string;
    valor: string;
    onChange: (valor: string) => void;
    error?: string | null;
    ayuda?: string | null;
    bloqueado?: boolean;
    /** Fecha máxima (`AAAA-MM-DD`), p. ej. hoy para una fecha de nacimiento. */
    max?: string;
    /** Fecha mínima (`AAAA-MM-DD`), p. ej. hoy para «Se aplica desde». */
    min?: string;
    nombre?: string;
    /** `oscuro` en el widget oscuro (G618): la píldora y el calendario del sistema en oscuro. */
    tema?: 'claro' | 'oscuro';
}

export function Fecha({ etiqueta, valor, onChange, error, ayuda, bloqueado = false, max, min, nombre, tema = 'claro' }: Props) {
    const idCampo = useId();
    const [foco, setFoco] = useState(false);
    const hayError = error != null && error !== '';
    const hayAyuda = !hayError && ayuda != null && ayuda !== '';
    const idNota = `${idCampo}-nota`;
    const caja = ['rv-campo__caja', 'rv-campo__caja--fecha', bloqueado ? 'rv-campo__caja--bloqueado' : '', foco ? 'rv-campo__caja--foco' : '', hayError ? 'rv-campo__caja--error' : ''].filter((c) => c !== '').join(' ');
    return (
        <div className={`rv-campo${tema === 'oscuro' ? ' rv-tema-oscuro' : ''}`} data-rv-tema={tema}>
            <div className="rv-campo__fila">
                <label htmlFor={idCampo} className={caja}>
                    <Icono nombre="calendar" className="rv-campo__calendario" />
                    <span className="rv-campo__etiqueta rv-campo__etiqueta--arriba">{etiqueta}</span>
                    <input
                        id={idCampo}
                        name={nombre ?? idCampo}
                        type="date"
                        value={valor}
                        max={max}
                        min={min}
                        disabled={bloqueado}
                        aria-invalid={hayError}
                        aria-describedby={hayError || hayAyuda ? idNota : undefined}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                        onFocus={() => {
                            setFoco(true);
                        }}
                        onBlur={() => {
                            setFoco(false);
                        }}
                    />
                </label>
            </div>
            {hayError && (
                <span id={idNota} role="alert" className="rv-campo__error">
                    <Icono nombre="circle-alert" />
                    <span>{error}</span>
                </span>
            )}
            {hayAyuda && (
                <span id={idNota} className="rv-campo__ayuda">
                    {ayuda}
                </span>
            )}
        </div>
    );
}
